import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"

const StickyBanner = ({
  children,
  navRevealed,
  secondaryNav,
  offsetCalculator: childOffsetCalculator,
}) => {
  const scrollDown = "scroll-down"
  const scrollUp = "scroll-up"
  const [scrollDirection, setScrollDirection] = useState(null)
  const [lastScroll, setLastScroll] = useState(0)
  const [startingPosition, setStartingPosition] = useState(null)
  const [offset, setOffset] = useState(0)
  const node = React.createRef()

  const defaultOffsetCalculator = (scrollDirection, _, currentScroll) => {
    if (scrollDirection === "scroll-down" && currentScroll > 250) {
      return `-${document.getElementById("main-header").clientHeight}px`
    } else {
      return 0
    }
  }
  const offsetCalculator = childOffsetCalculator || defaultOffsetCalculator

  useEffect(() => {
    if (startingPosition === null) {
      // set position on first load
      windowResized()
    }

    window.addEventListener("scroll", scrollHandler)
    window.addEventListener("resize", windowResized)
    return () => {
      window.removeEventListener("scroll", scrollHandler)
      window.removeEventListener("resize", windowResized)
    }
  })

  const windowResized = () => {
    setStartingPosition(
      node.current?.parentNode?.offsetTop
        ? node.current.parentNode.offsetTop
        : 0
    )
  }

  const scrollHandler = () => {
    const currentScroll = window.scrollY
    if (currentScroll > lastScroll) {
      setScrollDirection(scrollDown)
    } else if (currentScroll < lastScroll) {
      setScrollDirection(scrollUp)
    }
    setLastScroll(currentScroll)
    setOffset(
      offsetCalculator(scrollDirection, startingPosition, currentScroll)
    )
  }

  return (
    <div
      ref={node}
      css={`
        position: ${navRevealed ? "fixed" : "sticky"};
        top: 0;
        left: 0;
        right: 0;
        z-index: ${secondaryNav ? 5 : 10};
        transition: top 0.2s;
        top: ${!navRevealed && offset};
      `}
    >
      {children}
    </div>
  )
}

StickyBanner.propTypes = {
  children: PropTypes.element,
  hideAfter: PropTypes.number,
  navRevealed: PropTypes.bool,
  secondaryNav: PropTypes.bool,
  offsetCalculator: PropTypes.func,
}

export default StickyBanner
